import { FC } from 'react';
import { useRouter } from 'next/router';
import NextLink from 'next/link';

import {
  Button,
  Badge,
  ListItem,
  ListItemText,
  useTheme,
  ListItemProps,
  Typography
} from '@mui/material';
import { useTranslation } from 'next-i18next';

interface WorkspacesMenuButtonProps {
  link?: string;
  icon?: any;
  name: string;
  styles?: ListItemProps['sx'];
  isDisabled?: boolean;
  handleCloseMenu(): void;
}

export const WorkspacesMenuButton: FC<WorkspacesMenuButtonProps> = ({
  link,
  icon: Icon,
  name,
  styles,
  isDisabled,
  handleCloseMenu,
  ...rest
}) => {
  const theme = useTheme();
  const { pathname } = useRouter();
  const { t } = useTranslation();

  const activeColor = (): string => {
    return pathname.includes(link) ? theme.colors.primary.main : 'inherit';
  };

  const handleOnClick = () => {
    handleCloseMenu();
  };

  return (
    <ListItem component="div" key={name} {...rest}>
      <NextLink href={link || ''} passHref>
        <Button
          fullWidth
          disableRipple
          component="a"
          onClick={!isDisabled && handleOnClick}
          startIcon={
            Icon && (
              <Icon
                sx={{
                  '&:hover': {
                    backgroundColor: 'transparent'
                  }
                }}
              />
            )
          }
          sx={{
            color: `${isDisabled ? '#9e9e9e' : activeColor()}`,
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            '&:hover': {
              backgroundColor: 'transparent'
            },
            p: 0,
            ...styles
          }}
        >
          <ListItemText>
            <Typography sx={{ fontWeight: 700, pl: 0.25 }}>
              {t(name)}
            </Typography>
          </ListItemText>

          {isDisabled && (
            <Badge
              color="primary"
              badgeContent="WIP"
              style={{ opacity: 0.7 }}
            />
          )}
        </Button>
      </NextLink>
    </ListItem>
  );
};
